'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextInput = require('@narvar/nth-block-text-input');
var OrderLookupField_module = require('./OrderLookupField.module.css.js');
var TextLink = require('@narvar/nth-bit-text-link');
var StylelessButton = require('../../../../../common/components/StylelessButotn/StylelessButton.js');
var MagnifyingGlass = require('../../../../../common/components/Icon/MagnifyingGlass.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Typography = require('../../../../../common/components/Typography.js');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OrderLookupField = _ref => {
  let {
    orderNumber,
    onChange,
    onSubmit
  } = _ref;
  const {
    linksTrackingDefault,
    linksTrackingHover
  } = nthHookTheme.useTheme();
  const {
    claimsOrderClaimsOrderNumberLabel,
    claimsOrderClaimsOrderNumberLabelInput,
    claimsOrderClaimsEditOrderNumber,
    claimsOrderClaimsSetOrderNumber
  } = nthHookTranslations.useTranslations();
  const [editable, setEditable] = React.useState(false);
  const inputRef = React.useRef(null);
  const orderLookupFieldRef = React.useRef(null);
  React.useEffect(() => {
    if (editable) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    } else {
      var _orderLookupFieldRef$;
      (_orderLookupFieldRef$ = orderLookupFieldRef.current) === null || _orderLookupFieldRef$ === void 0 ? void 0 : _orderLookupFieldRef$.focus();
    }
  }, [editable]);
  if (!editable) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: OrderLookupField_module["default"].containerStatic
    }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, claimsOrderClaimsOrderNumberLabel), ":\xA0", orderNumber), /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
      linkStyle: {
        sDefault: linksTrackingDefault,
        sHover: linksTrackingHover
      },
      onClick: () => setEditable(true)
    }, claimsOrderClaimsEditOrderNumber));
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: OrderLookupField_module["default"].container,
    ref: orderLookupFieldRef,
    tabIndex: -1
  }, /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      setEditable(false);
      onSubmit();
    }
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: "orderNumber",
    label: claimsOrderClaimsOrderNumberLabelInput ?? '',
    value: orderNumber,
    onChange: e => onChange(e.target.value),
    animateLabel: true,
    inputRef: inputRef
  }), /*#__PURE__*/React__default["default"].createElement(StylelessButton.IconButtonThemed, {
    className: OrderLookupField_module["default"].orderLookup,
    type: "submit"
  }, /*#__PURE__*/React__default["default"].createElement(MagnifyingGlass["default"], {
    height: "1rem",
    width: "1rem"
  }, /*#__PURE__*/React__default["default"].createElement("title", null, claimsOrderClaimsSetOrderNumber)))));
};
var OrderLookupField$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OrderLookupField, {
  themeTokens: ['linksTrackingDefault', 'linksTrackingHover']
}), {
  translationKeys: ['claimsOrderClaimsOrderNumberLabel', 'claimsOrderClaimsOrderNumberLabelInput', 'claimsOrderClaimsSetOrderNumber', 'claimsOrderClaimsEditOrderNumber']
});

exports["default"] = OrderLookupField$1;
